<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			
		</div>
		<div class="add" v-if="type==='add'">
			<guahaoAdd></guahaoAdd>
		</div>
	</div>
</template>
<script>
	import guahaoAdd from "../comp/guahao_add.vue"
	export default {
		components:{guahaoAdd},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.guahaoParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
